$(document).ready(function () {
  if (document.querySelector(".styled-list__list")) {
    const styledLists = document.querySelectorAll(".styled-list__list");

    styledLists.forEach((list) => {
      const styledListItems = list.querySelectorAll(".styled-list__element");

      function hideElements() {
        styledListItems.forEach((item, index) => {
          if (index > 7) {
            item.classList.add("hide");
          }
        });
      }

      if (styledListItems.length > 8) {
        const itemHeight = styledListItems[0].offsetHeight;
        const listContainer = document.querySelector('.styled-list');
        const listContainerOffset = listContainer.offsetTop;
        const timeDelay = 5;

        hideElements();

        let active = false;

        const showButton = document.createElement("button");
        showButton.className = "styled-list__element styled-list__button";
        showButton.textContent = "Показать все квалификации";
        list.append(showButton);

        list.style.height = `${8 * itemHeight + showButton.offsetHeight + 6}px`;

        showButton.addEventListener("click", () => {
          if (active) {
            let waitTime = styledListItems.length * timeDelay;
            window.scrollTo({
              top: listContainerOffset,
              behavior: 'smooth',
            });

            setTimeout(function () {
              list.style.height = `${8 * itemHeight + showButton.offsetHeight + 6}px`;
            }, waitTime);

            list.style.overflow = 'hidden';
            listContainer.style.removeProperty('margin-bottom');
            showButton.style.bottom = '0';

            active = false;
						showButton.textContent = "Показать все квалификации";
            setTimeout(() => {
              hideElements();
            }, waitTime);
          } else {
            styledListItems.forEach((item) => {
              item.classList.remove("hide");
            });

            list.style.removeProperty('height');
            list.style.overflow = 'initial';
            listContainer.style.marginBottom = '80px';
            showButton.style.bottom = '-40px';

            active = true;
						showButton.textContent = "Свернуть все квалификации";
          }
        });
      }
    });
  }
});
